'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _AboutRealtor = require('./AboutRealtor.scss');var styles = _interopRequireWildcard(_AboutRealtor);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var AboutRealtor = function AboutRealtor(properties) {return (
    _react2.default.createElement('div', { className: styles.aboutRealtor },
      _react2.default.createElement('h1', null, properties.title),

      _react2.default.createElement('div', { className: 'realtor-contacts' },
        properties.profileImage &&
        _react2.default.createElement('div', { className: 'realtor-logo', style: { backgroundImage: 'url(' + properties.profileImage + ')' } }),

        _react2.default.createElement('div', { className: 'realtor-contact-info' },
          properties.companyName &&
          _react2.default.createElement('p', null,
            _react2.default.createElement('i', { className: 'icon icon-office' }),
            _react2.default.createElement('span', null, properties.companyName)),



          _react2.default.createElement('p', null,
            _react2.default.createElement('i', { className: 'icon icon-user' }),
            _react2.default.createElement('span', null, properties.name)),


          _react2.default.createElement('p', null,
            _react2.default.createElement('i', { className: 'icon icon-phone' }),

            properties.isMobile ?
            _react2.default.createElement('a', { href: 'tel:' + properties.phoneNumber, 'data-rel': 'external' }, properties.phoneNumber) :

            _react2.default.createElement('span', null, properties.phoneNumber)),



          _react2.default.createElement('p', { className: 'blank-line' }),

          _react2.default.createElement('p', null, properties.translate('licenseNumber'), ': ', properties.licenseNumber),
          _react2.default.createElement('p', null, properties.translate('licenseFrom'), ': ', properties.licenseFrom))),



      properties.description && _react2.default.createElement('hr', null),

      properties.description &&
      _react2.default.createElement('h2', { className: 'realtor-description' },
        _react2.default.createElement('pre', null,
          properties.description))));};






AboutRealtor.propTypes = {
  translate: _propTypes2.default.func,
  companyName: _propTypes2.default.string,
  name: _propTypes2.default.string,
  phoneNumber: _propTypes2.default.string,
  licenseNumber: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  licenseFrom: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  description: _propTypes2.default.string,
  profileImage: _propTypes2.default.string,
  title: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool };exports.default =


AboutRealtor;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AboutRealtor/AboutRealtor.js
// module id = 2595
// module chunks = 0